import { defaultGroupedFilter } from 'module/types/filter-field/grouped-filter/filter';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { GroupFieldsMeta } from 'module/types/filter-field/transformer/filter-transformer';
import { getApiGroupedFilterTransformer } from 'module/ui/components/molecules/field-filter/filter-transformation/api-grouped-filter-transformer';
import {
  PeoplePageTemplate,
  TemporaryPeoplePageTemplate,
} from 'api/people-page-template/types';
import { PeoplePageTemplateState } from '../manage/types';

export const initialState = (): PeoplePageTemplateState => ({
  name: 'Untitled',
  tiptapJson: {
    loading: false,
    json: {
      type: 'doc',
      content: [],
    },
  },
  filter: defaultGroupedFilter(FilterGroupType.User),
});
export const apiToState = (
  template: PeoplePageTemplate,
  fieldsLookup: GroupFieldsMeta,
): PeoplePageTemplateState => {
  const filterTransformer = getApiGroupedFilterTransformer(
    fieldsLookup,
    FilterGroupType.User,
  );

  return {
    name: template.templateName,
    tiptapJson: {
      loading: false,
      json: template.tiptapJson,
    },
    filter: template.filters.pageTriggerCondition
      ? filterTransformer.from(template.filters.pageTriggerCondition)
      : defaultGroupedFilter(FilterGroupType.User),
  };
};

export const temporaryApiToState = (
  template: TemporaryPeoplePageTemplate,
  _fieldsLookup: GroupFieldsMeta,
) => {
  return {
    ...initialState(),
    name: template.templateName,
  };
};
